import { AngelouCSS } from "@newsela/angelou";
import { AriaAttributes } from "react";
import {
  gradientCss,
  loaderWrapperCss,
  loaderCss,
} from "./AILoadingSpinner.style";

export interface AILoadingSpinnerStyleOverrides<T> {
  root?: T;
}

export interface AILoadingSpinnerProps {
  /**
   * Object that allows you to pass an object, string, or array representing css
   * rules that override the default styles of different parts of the component.
   */
  __cssFor?: AILoadingSpinnerStyleOverrides<AngelouCSS>;
  /**
   * Object that allows you to pass classNames to various elements comprising
   * the component.
   */
  __classNameFor?: AILoadingSpinnerStyleOverrides<string>;

  /**
   * aria props that will be spread on the svg
   */
  ariaProps?: AriaAttributes;

  /**
   * data props that will be spread on the svg itself
   */
  dataProps?: object;

  /**
   * title of the AILoadingSpinner. defaults to "Loading Content"
   */
  title?: string;
}

export const AILoadingSpinner = (props: AILoadingSpinnerProps) => {
  const {
    ariaProps = {},
    dataProps = {},
    __cssFor = {},
    __classNameFor = {},
    title = "Loading AI Content",
  } = props;
  return (
    <div
      role="img"
      aria-label={title}
      className={__classNameFor?.root}
      css={[loaderWrapperCss, __cssFor?.root]}
      {...ariaProps}
      {...dataProps}
    >
      <svg aria-hidden viewBox="0 0 100 100" css={loaderCss}>
        <linearGradient css={gradientCss} id="gradient">
          <stop offset="0%" />
          <stop offset="25%" />
          <stop offset="50%" />
          <stop offset="100%" />
        </linearGradient>
        <circle cx="50" cy="50" fill="none" />
      </svg>
    </div>
  );
};

AILoadingSpinner.displayName = "AILoadingSpinner";

export default AILoadingSpinner;
